/* eslint-disable */
export default {
    isBrowser: () => {
        return typeof window !== 'undefined';
    },
    isNode: () => {
        return typeof window === 'undefined' && typeof process !== 'undefined';
    }
};
/* eslint-enable */



/** WEBPACK FOOTER **
 ** ./src/utils/platform/index.js
 **/